module.exports = __webpack_public_path__ + "8d659f8daf24f96fbc155bf9cd73e12a.svg";